import { lazy } from "react";

const HomePage = lazy(() => import("./quantity-unit-page"));

const routes = [
  {
    path: "/quantity-units",
    component: HomePage,
    exact: true,
    name: "Unidades de Cantidad de Dietas de Nutrición"
  }
];

export default routes;
